import type { FC } from 'react'

import { Group, Stack, Text } from '@mantine/core'
import { CircleHelp } from 'lucide-react'

type AccountHelpfulInfoProps = {
  accountAlias: string
  title: string
  description: string
}

const AccountHelpfulInfo: FC<AccountHelpfulInfoProps> = (props) => {
  const { accountAlias, title, description } = props
  const accountAliasPlaceholder = `<${accountAlias}>`

  return (
    <Stack gap='md'>
      <Stack gap='xs'>
        <Group gap='xs'>
          <CircleHelp nonScalingStroke size={12} strokeWidth={1} />
          <Text fz='xs' fw='500'>
            {title}
          </Text>
        </Group>
        <Text c='dimmed' fz='xs'>
          {description}
        </Text>
      </Stack>
      <Group
        bd='1px solid var(--mantine-color-border-surface)'
        bg='var(--mantine-color-item-bg-selected)'
        gap='xs'
        px={12}
        py={6}
        w='100%'
        style={{
          borderRadius: 'var(--mantine-radius-md)',
        }}
      >
        <Text c='dimmed' fz='xs'>
          https://
        </Text>
        <Text ff='monospace' fw='500' fz='2xs' tt='uppercase'>
          {accountAliasPlaceholder}
        </Text>
        <Text c='dimmed' fz='xs'>
          .shalion.com
        </Text>
      </Group>
    </Stack>
  )
}

export default AccountHelpfulInfo
